import { Box, Paper, Select, Typography, MenuItem, TableContainer, Table, TableBody, Button, TablePagination, Menu, CircularProgress, IconButton } from "@mui/material"
import AuditStudentChecklistDetailsDialog from "../../../components/academic-program/AuditStudentChecklistDetailsDialog"
import BranchAcademicProgressStatsDialog from "../../../components/academic-program/BranchAcademicProgressStatsDialog"
import { filterBranches, structureData } from "../../../utils/academic-program-utilities"
import CustomTableColumnLabel from "../../../components/common/CustomTableColumnLabel"
import AuditFilterDialog from "../../../components/academic-program/AuditFilterDialog"
import AuditStudentRow from "../../../components/academic-program/AuditStudentRow"
import { Icons, exportAcademicProgressReport } from "../../../utils/utilities"
import DataLoadingSpinner from "../../../components/common/DataLoadingSpinner"
import CustomSearchBar from "../../../components/common/CustomSearchBar"
import { useOrganizationStore } from '../../../store/organization.store'
import BlockMessage from "../../../components/common/BlockMessage"
import noStudentsImg from '../../../assets/no-proctees.svg'
import { useUserStore } from "../../../store/user.store"
import noRuleImg from '../../../assets/no-rules.svg'
import React, { useCallback, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import api from "../../../service/api"
import { toast } from "react-toastify"
import { observer } from "mobx-react"
import TableHeader from "../../../components/common/TableHeader"
import BreadcrumbList from "../../../components/common/BreadcrumbList"


const AcademicProgressAudit = observer( () => {
    const [requiredChecklistItemsCount, setRequiredChecklistItemsCount] = useState( 0 )
    const [showRemoveFilterSection, setShowRemoveFilterSection] = useState( false )
    const [filteredAndSortedData, setFilteredAndSortedData] = useState( [] )
    const [detailsDialogState, setDetailsDialogState] = useState( false )
    const [filtersDialogState, setFiltersDialogState] = useState( false )
    const [statsDialogState, setStatsDialogState] = useState( false )
    const [exportMenuAnchor, setExportMenuAnchor] = useState( null )
    const [currentDataLength, setCurrentDataLength] = useState( 0 )
    const [filteredBranches, setFilteredBranches] = useState( [] )
    const [selectedStudent, setSelectedStudent] = useState( null )
    const [filtersDetails, setFiltersDetails] = useState( {} )
    const [hasPermission, setHasPermission] = useState( true )
    const [academicYears, setAcademicYears] = useState( [] )
    const [loadingData, setLoadingData] = useState( false )
    const [rowsPerPage, setRowsPerPage] = useState( 20 )
    const [filtersCount, setFiltersCount] = useState( 0 )
    const [allBranches, setAllBranches] = useState( [] )
    const [exporting, setExporting] = useState( false )
    const [errorCode, setErrorCode] = useState( null )
    const [loading, setLoading] = useState( true )
    const [rules, setRules] = useState( {} )
    const [data, setData] = useState( [] )
    const [page, setPage] = useState( 0 )


    const [searchParams, setSearchParams] = useSearchParams( {
        selectedInstitute: "-",
        selectedBranch: "-",
        academicYear: "-",
        searchText: "",
        sortByAUID: "0",
        sortByName: "0",
        sortByProgress: "-1"
    } )

    const selectedInstitute = searchParams.get( "selectedInstitute" ) || "-"
    const selectedBranch = searchParams.get( "selectedBranch" ) || "-"
    const sortByProgress = searchParams.get( "sortByProgress" ) || "-1"
    const academicYear = searchParams.get( "academicYear" ) || "-"
    const searchText = searchParams.get( "searchText" ) || ""
    const sortByAUID = searchParams.get( "sortByAUID" ) || "0"
    const sortByName = searchParams.get( "sortByName" ) || "0"

    const UserStore = useUserStore()
    const OrganizationStore = useOrganizationStore()
    const exportMenuOpen = Boolean( exportMenuAnchor )


    const setSearchParamValue = ( key, val ) => {
        setSearchParams( prev => {
            prev.set( key, val )
            return prev
        }, { replace: true } )
    }


    const columns = [
        { id: 1, name: <CustomTableColumnLabel data={filteredAndSortedData} setData={setFilteredAndSortedData} label="AUID" setSortState={setSearchParamValue} sortKey={"auid"} sortName="sortByAUID" sortFlag={sortByAUID} sortValueType="string" />, styles: { minWidth: "150px", padding: "10px 20px" } },
        { id: 2, name: <CustomTableColumnLabel data={filteredAndSortedData} setData={setFilteredAndSortedData} label="Student Name" setSortState={setSearchParamValue} sortKey={"student_name"} sortName="sortByName" sortFlag={sortByName} sortValueType="string" />, styles: { minWidth: "200px", maxWidth: "200px", padding: "10px 20px" } },
        { id: 8, name: "Total items", align: "center", styles: { minWidth: "100px", padding: "10px 20px" } },
        { id: 3, name: "Required", align: "center", styles: { minWidth: "50px", padding: "10px 20px" } },
        { id: 7, name: "Req. Submission pending", align: "center", styles: { minWidth: "180px", padding: "10px 20px" } },
        { id: 4, name: <CustomTableColumnLabel align="center" data={filteredAndSortedData} setData={setFilteredAndSortedData} label="Approval Pending" setSortState={setSearchParamValue} sortKey={"pendingCount"} sortName="sortByProgress" sortFlag={sortByProgress} sortValueType="number" />, styles: { minWidth: "180px", padding: "10px 20px" } },
        { id: 5, name: "Pending data", styles: { minWidth: "200px", padding: "10px 20px" } },
        { id: 6, name: <CustomTableColumnLabel align="right" data={filteredAndSortedData} setData={setFilteredAndSortedData} label="Progress" setSortState={setSearchParamValue} sortKey={"totalProgress"} sortName="sortByProgress" sortFlag={sortByProgress} sortValueType="number" />, styles: { align: "right", minWidth: "100px", padding: "10px 20px" } },
    ]

    const getData = useCallback( async ( branchId = selectedBranch, acYear = academicYear, applyingFilters = filtersDetails ) => {
        try {

            const academicYearDetails = academicYears.find( ay => ay.ac_year_id + "" === acYear + "" )
            const selectedInstituteDetails = OrganizationStore.getOrganization?.find( i => i.institute_name_short === selectedInstitute )

            setLoadingData( true )
            setErrorCode( null )
            const { data: { data: { students, progressDetails, requiredChecklistItemsCount, rules, optionalChecklistItemsCount, appliedFilter } } } = await api.getBranchStudentsProgressReport( { institute: selectedInstituteDetails.institute_name_short, institute_id: selectedInstituteDetails.institute_id, branch_id: branchId, ac_year_id: academicYearDetails.ac_year_id, ac_year: academicYearDetails.ac_year }, applyingFilters )

            setRules( rules )
            setRequiredChecklistItemsCount( requiredChecklistItemsCount )

            if ( requiredChecklistItemsCount === 0 && optionalChecklistItemsCount === 0 )
                toast.warn( "No checklist for this class!" )

            const formatedData = structureData( students, appliedFilter, requiredChecklistItemsCount, optionalChecklistItemsCount, progressDetails )

            if ( !appliedFilter?.filter || appliedFilter?.filter === "" )
                setData( formatedData )
            return true

        } catch ( err ) {
            console.log( err )

            setData( [] )
            setFilteredAndSortedData( [] )
            setRequiredChecklistItemsCount( 0 )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth === true )
                return UserStore.setERPSessionState( "ended" )
            setErrorCode( err?.response?.data?.errorCode )
            if ( !( err?.response?.data?.errorCode ) )
                toast(
                    err?.response?.data?.message ||
                    "Something went wrong! try again."
                )
            return false
        } finally {
            setLoadingData( false )
        }
    }, [OrganizationStore, UserStore, academicYears, academicYear, filtersDetails, selectedBranch, selectedInstitute] )

    const handleInstituteChange = ( e ) => {
        setSearchParams( prev => {
            const newParams = new URLSearchParams( prev )
            newParams.set( 'selectedInstitute', e.target.value )
            newParams.set( 'selectedBranch', "-" )
            newParams.set( 'academicYear', "-" )
            return newParams
        }, { replace: true } )
        filterBranches( e.target.value, allBranches, setFilteredBranches )
    }

    const handleBranchChange = async ( e ) => {
        try {
            setErrorCode( null )
            setSearchParamValue( 'selectedBranch', e.target.value )
            if ( academicYear && academicYear.match( /^(\d\d\d\d-\d\d\d\d)$/ ) ) {
                await getData( e.target.value, academicYear, {} )
            } else {
                setSearchParamValue( 'academicYear', '-' )
            }
        } catch ( err ) {
            if ( !( err?.response?.data?.errorCode ) )
                toast(
                    err?.response?.data?.message ||
                    "Something went wrong! try again."
                )
        }
    }

    const handleAcademicYearChange = async ( e ) => {
        setSearchParamValue( 'academicYear', e.target.value )
        setErrorCode( null )
        try {
            if ( selectedBranch !== "-" ) {
                await getData( selectedBranch, e.target.value, {} )
            }
        } catch ( err ) {
            if ( !( err?.response?.data?.errorCode ) )
                toast(
                    err?.response?.data?.message ||
                    "Something went wrong! try again."
                )
        }
    }

    const handleChangePage = ( event, newPage ) => {
        setPage( newPage )
    }

    const handleChangeRowsPerPage = ( event ) => {
        setRowsPerPage( parseInt( event.target.value, 10 ) )
        setPage( 0 )
    }

    const handleSearchTextChange = ( e ) => {
        setSearchParamValue( 'searchText', e.target.value )
    }

    const exportWithFilters = async () => {
        try {
            setExporting( true )
            await exportAcademicProgressReport( filteredAndSortedData, { branch: filteredBranches.find( i => i.course_branch_assignment_id === selectedBranch ), academicYear } )
        } catch ( err ) {
            toast( "Error occured while exporting report" )
        } finally {
            setExporting( false )
        }
    }

    const exportWithOutFilters = async () => {
        try {
            setExporting( true )
            await exportAcademicProgressReport( data, { branch: filteredBranches.find( i => i.course_branch_assignment_id === selectedBranch ), academicYear } )
        } catch ( err ) {
            toast( "Error occured while exporting report" )
        } finally {
            setExporting( false )
        }
    }

    const handleRemoveFilters = async () => {
        if ( filtersCount > 0 ) {
            setFiltersDetails( {} )
            await getData( selectedBranch, academicYear, {} )
        }
        setSearchParamValue( 'searchText', "" )
    }

    const handleExportDataButtonClick = async ( e ) => {
        if ( filtersCount === 0 )
            await exportWithOutFilters()
        else
            setExportMenuAnchor( e.currentTarget )
    }

    const cachedSetSearchParamValue = useCallback( setSearchParamValue, [setSearchParams] )

    useEffect( () => {
        const len = filteredAndSortedData.filter( i => ( i.student_name.toLowerCase().includes( searchText ) || i.auid.toLowerCase().includes( searchText ) ) ).length
        setCurrentDataLength( len )
        setShowRemoveFilterSection( len === 0 && data.length > 0 )
    }, [searchText, filteredAndSortedData, data] )

    useEffect( () => {
        const len = ( filtersDetails?.filter?.length > 0 ? 1 : 0 ) + ( filtersDetails?.frontFilter?.length > 0 ? 1 : 0 )
        setFiltersCount( len )
        cachedSetSearchParamValue( 'filter', filtersDetails?.filter )
        cachedSetSearchParamValue( 'filterData', filtersDetails?.filterData )
    }, [filtersDetails, cachedSetSearchParamValue] )


    useEffect( () => {
        const getInitialData = async () => {
            try {
                if ( OrganizationStore.getOrganization?.length === 0 )
                    await OrganizationStore.fetchOrganization()
                const { data: { data: branches } } = await api.fetchAllBranches()
                const { data: { data: academicYearsList } } = await api.fetchAllAcademicYears()
                setAcademicYears( academicYearsList )
                setAllBranches( branches )
            } catch ( err ) {
                console.log( err )
                toast( err?.response?.data?.message || "Something went wrong! try again." )
            } finally {
                setLoading( false )
            }
        }
        if ( UserStore.getUser.user_role === 'SUBADMIN' && !UserStore.getUser.user_permissions.academics ) {
            setHasPermission( false )
        } else
            getInitialData()

    }, [UserStore, OrganizationStore] )

    useEffect( () => {
        if ( selectedInstitute !== "-" ) {
            setFilteredBranches( allBranches.filter( branch => branch.institute_name_short === selectedInstitute ) )
        }
    }, [selectedInstitute, allBranches] )

    return (
        hasPermission ? <Box flexGrow={1} display="flex" flexDirection="column" overflow="auto" padding="20px">
            {/* Export Menu */}
            <Menu onClose={() => setExportMenuAnchor( null )} open={exportMenuOpen} anchorEl={exportMenuAnchor}>
                <MenuItem onClick={exportWithFilters} >Export with filters</MenuItem>
                <MenuItem onClick={exportWithOutFilters} >Export without filters</MenuItem>
            </Menu>

            {/* Dialogs */}
            {selectedStudent && <AuditStudentChecklistDetailsDialog rules={rules} state={detailsDialogState} setState={setDetailsDialogState} student={selectedStudent} setStudent={setSelectedStudent} />}
            <AuditFilterDialog filtersDetails={filtersDetails} setFiltersDetails={setFiltersDetails} state={filtersDialogState} getData={getData} setState={setFiltersDialogState} />
            {data.length > 0 && <BranchAcademicProgressStatsDialog setState={setStatsDialogState} data={{ data, totalRequired: requiredChecklistItemsCount }} branchDetails={{ branch: filteredBranches.find( i => +i.course_branch_assignment_id === +selectedBranch ) || {}, academicYear: academicYears.find( ay => +ay.ac_year_id === +academicYear ) }} state={statsDialogState} />}

            {/* Breadcrunm */}
            <BreadcrumbList items={[
                "Academics", "Audit", UserStore.getUser?.user_org_code
            ]} />

            {/* Content */}
            <Paper sx={{ minHeight: !loading && !loadingData ? currentDataLength > 0 ? "800px" : "600px" : "initial", flexGrow: ( loading || data.length === 0 || filteredAndSortedData.length === 0 || errorCode ) ? "initial" : "1", display: "flex", flexDirection: "column" }}>
                <Box display="flex" flexWrap="wrap" gap="20px" alignItems="center" padding="20px" borderBottom="1px solid #d3d3d3" >

                    <Box flexGrow={1}>
                        <Typography variant="h5">
                            Audit students academic progress
                        </Typography>
                        <Typography variant="subtitle2" color="textSecondary">
                            Audit department's students academic progress here.
                        </Typography>
                    </Box>

                    {!loading && (
                        <Box display="flex" flexWrap="wrap" gap="10px" alignItems="center">

                            <Select
                                disabled={loading}
                                variant="outlined"
                                sx={{ fontSize: "14px", flexGrow: 1, outline: "none", border: "none" }}
                                size="small"
                                onChange={handleInstituteChange}
                                value={selectedInstitute}
                            >
                                <MenuItem dense value={"-"} disabled sx={{ fontSize: "12px" }} >Select institute</MenuItem>

                                {OrganizationStore.getOrganization.map( ( institute, index ) => (
                                    <MenuItem dense value={institute.institute_name_short} sx={{ fontSize: "12px", textTransform: "capitalize", display: "flex", gap: "5px", alignItems: "center", }} key={institute.institute_name_short} >{institute.institute_name_short}</MenuItem>
                                ) )}
                            </Select>

                            {filteredBranches && (
                                <Select
                                    disabled={selectedInstitute === "-"}
                                    variant="outlined"
                                    sx={{ fontSize: "14px", flexGrow: 1, outline: "none", border: "none", textTransform: "capitalize" }}
                                    size="small"
                                    onChange={e => handleBranchChange( e )}
                                    value={selectedBranch === "-" ? "-" : +selectedBranch}
                                    renderValue={( val ) => {
                                        const branch = val !== "-" ? filteredBranches.find( i => i.course_branch_assignment_id === val ) || {} : {}
                                        return val !== "-" && branch ? <Typography noWrap textTransform="capitalize" fontSize="14px" minWidth="130px" width="130px">
                                            {branch?.course_name?.toLowerCase()}-{branch?.course_branch_short_name}
                                        </Typography> : <Typography noWrap textTransform="capitalize" fontSize="14px" minWidth="130px" width="130px">
                                            Select Branch
                                        </Typography>
                                    }}
                                >
                                    <MenuItem dense value={"-"} disabled sx={{ fontSize: "12px" }} >Select branch</MenuItem>

                                    {filteredBranches.map( ( branch, index ) => (
                                        <MenuItem dense value={`${branch.course_branch_assignment_id}`} sx={{ fontSize: "12px", textTransform: "capitalize", display: "flex", gap: "5px", alignItems: "center", }} key={branch.course_branch_assignment_id} >{branch.course_name.toLowerCase()}{" "}{" - "}{" "}<b>{" "}{branch.course_branch_short_name}</b>{" "}</MenuItem>
                                    ) )}
                                </Select>
                            )}

                            <Select variant="outlined" sx={{ fontSize: "14px", flexGrow: 1, outline: "none", border: "none" }} disabled={selectedBranch === "-"} size="small" onChange={handleAcademicYearChange} value={academicYear}>
                                <MenuItem dense value={"-"} disabled sx={{ fontSize: "12px" }} >Academic year</MenuItem>

                                {academicYears.map( ( year ) => (
                                    <MenuItem dense value={year.ac_year_id} sx={{ fontSize: "12px", textTransform: "capitalize", display: "flex", gap: "5px", alignItems: "center", }} key={year.ac_year_id} >
                                        {year.ac_year}
                                    </MenuItem>
                                ) )}
                            </Select>
                        </Box>
                    )}
                </Box>
                {!loading && !loadingData && data.length > 0 && (
                    <Box display="flex" flexDirection="column" flexGrow={1} height={data.length > 0 && "50px"}>

                        {filteredAndSortedData && filteredAndSortedData.length > 0 && <Box padding="10px 20px" flexWrap="wrap" display="flex" flexDirection={{ md: "row", xs: "column" }} gap="10px" alignItems={{ md: "center", xs: "stretch" }} borderBottom="1px solid #d3d3d3">
                            <CustomSearchBar style={{ flexGrow: 1, margin: "0", padding: "0" }} placeholder="Search student by name or AUID" value={searchText} onChange={handleSearchTextChange} border="1px solid #d3d3d3" />
                            <Box display={{ sm: "flex", xs: "none" }} gap="10px" alignItems="center" height={{ md: "100%", xs: "fit-content" }}>
                                <Button onClick={() => setFiltersDialogState( true )} variant="contained" disableElevation sx={{ flexGrow: "1 !important", height: "100%", textTransform: "capitalize", width: "max-content" }} startIcon={Icons.default.FilterAlt}>Filters ({filtersCount})</Button>
                                <Button disabled={exporting} onClick={handleExportDataButtonClick} color="secondary" variant="contained" disableElevation sx={{ flexGrow: "1 !important", height: "100%", textTransform: "capitalize", width: "max-content" }} startIcon={exporting ? <CircularProgress size={14} /> : Icons.default.DownloadIcon}>Export</Button>
                                <Button onClick={() => setStatsDialogState( true )} color="success" variant="contained" disableElevation sx={{ flexGrow: "1 !important", height: "100%", textTransform: "capitalize", width: "max-content" }} startIcon={Icons.default.AnalyticsIcon} >Stats</Button>
                            </Box>
                            <Box display={{ sm: "none", xs: "flex" }} gap="10px" justifyContent="space-evenly" alignItems="center" height={{ md: "100%", xs: "fit-content" }}>
                                <IconButton color="primary" size="small" onClick={() => setFiltersDialogState( true )}  >{Icons.default.FilterAlt} ({filtersCount})</IconButton>
                                <IconButton color="primary" size="small" disabled={exporting} onClick={handleExportDataButtonClick}  >{exporting ? <CircularProgress size={14} /> : Icons.default.DownloadIcon}</IconButton>
                                <IconButton color="primary" size="small" onClick={() => setStatsDialogState( true )}  >{Icons.default.AnalyticsIcon} </IconButton>
                            </Box>
                        </Box>}

                        {data && data.length > 0 && !loading && <Box flexGrow={1} display="flex" flexDirection="column" overflow="hidden">
                            {currentDataLength > 0 && <TableContainer className="custom-scrollbar" sx={{ overflow: "auto", height: "100%", position: "relative" }}>
                                <Table stickyHeader>
                                    <TableHeader columns={columns} />
                                    <TableBody>
                                        {filteredAndSortedData
                                            .filter( i => ( i.student_name.toLowerCase().includes( searchText ) || i.auid.toLowerCase().includes( searchText ) ) )
                                            .slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                            .map( ( item, index ) => {
                                                return (
                                                    <AuditStudentRow key={index} setDetailsDialogState={setDetailsDialogState} setSelectedStudent={setSelectedStudent} requiredChecklistItemsCount={requiredChecklistItemsCount} item={item} />
                                                )
                                            }
                                            )}
                                    </TableBody>
                                </Table>
                                {currentDataLength > 10 && <TablePagination sx={{ background: "#eee", position: "sticky", bottom: 0, left: 0, right: 0 }} rowsPerPageOptions={[10, 20, 30]} component="div" count={currentDataLength} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage}
                                />}
                            </TableContainer>}

                            {showRemoveFilterSection === 0 && <Box justifyContent="center" alignItems="center" flexGrow={1} display="flex" flexDirection="column" gap="10px">
                                <img src={noStudentsImg} width="140px" alt="no-students-filter" />
                                <Typography variant="subtitle2" color="textSecondary">No students present for the applied filters!</Typography>
                                <Button color="error" onClick={handleRemoveFilters} variant="outlined" sx={{ textTransform: "capitalize" }} startIcon={Icons.default.FilterAltOff}>Remove all filters</Button>
                            </Box>}
                        </Box>}
                    </Box>
                )}
                {!loading && !loadingData && ( data?.length === 0 || errorCode ) && <Box flexGrow={1} display="flex" flexDirection="column" gap="10px">
                    {data?.length === 0 && !errorCode &&
                        <Box flexGrow={1} justifyContent="center" display="flex" flexDirection="column" gap="10px" padding="20px" alignItems="center">
                            <img src={noStudentsImg} width="170px" alt={"no-students"} />
                            <Typography textAlign="center" variant="subtitle2" color="textSecondary">No students present for the selected academic year and branch</Typography>
                        </Box>
                    }
                    {errorCode === "NORULE" &&
                        <Box flexGrow={1} justifyContent="center" display="flex" flexDirection="column" gap="10px" padding="20px" alignItems="center">
                            <img src={noRuleImg} width="170px" alt={"no-rules"} />
                            <Typography textAlign="center" variant="subtitle2" color="GrayText">No rule present for the selected academic year and branch</Typography>
                        </Box>
                    }
                    {errorCode === "NOSTUDENTS" &&
                        <Box flexGrow={1} justifyContent="center" display="flex" flexDirection="column" gap="10px" padding="20px" alignItems="center">
                            <img src={noStudentsImg} width="170px" alt={"no-students"} />
                            <Typography textAlign="center" variant="subtitle2" color="textSecondary">No students present for the selected academic year and branch</Typography>
                        </Box>
                    }
                </Box>}
                {( loadingData || loading ) && (
                    <DataLoadingSpinner waitingMessage="Loading data..." />
                )}
            </Paper>
        </Box> :
            <Box padding="20px">
                <BlockMessage message={<span>You doesn't have permission to access this page! please contact <i>Alive co-ordinators</i> for further information.</span>} type="error" />
            </Box>
    )
} )

export default AcademicProgressAudit    